import React from 'react';
import {
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  TextField,
  Paper,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    paddingLeft: 0,
    paddingRight: 0,
  },
  paper: {
    margin: '10px 0',
    padding: '40px',
    width: '100%',
    boxSizing: 'border-box',
  },
  fieldsContainer: {
    marginTop: '10px',
    marginBottom: '10px',
    padding: '10px',
  },
  textfield: {
    marginLeft: '20px',
    marginRight: '20px',
    marginBottom: '12px',
    width: '320px',
  },
  checkboxContainer: {
    marginTop: '20px',
    marginBottom: '30px',
  },
}));

const FormDettagli = ({
  record,
  handleChange,
  validationErrors,
  gestioneOperativaOpen = false,
}) => {
  const classes = useStyles();

  return (
    <Container className={classes.container}>
      <Grid container justify="center" alignItems="center">
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Grid container className={classes.fieldsContainer}>
              <Grid item xs={12} md={6}>
                <Grid container direction="column" alignItems="center">
                  <TextField
                    label="ID esercizio"
                    disabled
                    value={
                      record.esercizio.id === null ? '' : record.esercizio.id
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                    className={classes.textfield}
                  />
                  <TextField
                    label="ID consulente"
                    disabled
                    value={
                      record.esercizio.consulenteId === null
                        ? ''
                        : record.esercizio.consulenteId
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                    className={classes.textfield}
                  />
                  <TextField
                    label="Nome"
                    value={
                      record.esercizio.nome === null
                        ? ''
                        : record.esercizio.nome
                    }
                    name="nome"
                    onChange={handleChange}
                    className={classes.textfield}
                    helperText={validationErrors.nome}
                    error={validationErrors.nome.length > 0}
                  />
                  <TextField
                    label="Ragione sociale"
                    value={
                      record.esercizio.ragioneSociale === null
                        ? ''
                        : record.esercizio.ragioneSociale
                    }
                    name="ragioneSociale"
                    onChange={handleChange}
                    className={classes.textfield}
                    helperText={validationErrors.ragioneSociale}
                    error={validationErrors.ragioneSociale.length > 0}
                  />
                  <TextField
                    label="Partita IVA"
                    value={
                      record.esercizio.partitaIva === null
                        ? ''
                        : record.esercizio.partitaIva
                    }
                    name="partitaIva"
                    onChange={handleChange}
                    className={classes.textfield}
                  />
                  <TextField
                    label="Codice ATECO"
                    value={
                      record.esercizio.codiceAteco === null
                        ? ''
                        : record.esercizio.codiceAteco
                    }
                    name="codiceAteco"
                    onChange={handleChange}
                    className={classes.textfield}
                  />
                  <TextField
                    label="Telefono"
                    value={
                      record.esercizio.telefono === null
                        ? ''
                        : record.esercizio.telefono
                    }
                    name="telefono"
                    onChange={handleChange}
                    className={classes.textfield}
                  />
                  <TextField
                    label="Nome titolare"
                    value={
                      record.esercizio.nomeGestore === null
                        ? ''
                        : record.esercizio.nomeGestore
                    }
                    name="nomeGestore"
                    onChange={handleChange}
                    className={classes.textfield}
                  />
                  <TextField
                    label="Cognome titolare"
                    value={
                      record.esercizio.cognomeGestore === null
                        ? ''
                        : record.esercizio.cognomeGestore
                    }
                    name="cognomeGestore"
                    onChange={handleChange}
                    className={classes.textfield}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <Grid container direction="column" alignItems="center">
                  <TextField
                    label="Email titolare"
                    value={
                      record.esercizio.emailGestore === null
                        ? ''
                        : record.esercizio.emailGestore
                    }
                    name="emailGestore"
                    onChange={handleChange}
                    className={classes.textfield}
                    helperText={validationErrors.emailGestore}
                    error={validationErrors.emailGestore.length > 0}
                  />
                  <TextField
                    label="Telefono titolare"
                    value={
                      record.esercizio.telefonoGestore === null
                        ? ''
                        : record.esercizio.telefonoGestore
                    }
                    name="telefonoGestore"
                    onChange={handleChange}
                    className={classes.textfield}
                  />
                  <TextField
                    label="Indirizzo"
                    value={
                      record.esercizio.indirizzoSede === null
                        ? ''
                        : record.esercizio.indirizzoSede
                    }
                    name="indirizzoSede"
                    onChange={handleChange}
                    className={classes.textfield}
                  />
                  <TextField
                    label="Numero civico"
                    value={
                      record.esercizio.numeroSede === null
                        ? ''
                        : record.esercizio.numeroSede
                    }
                    name="numeroSede"
                    onChange={handleChange}
                    className={classes.textfield}
                  />

                  <TextField
                    label="Città"
                    value={
                      record.esercizio.cittaSede === null
                        ? ''
                        : record.esercizio.cittaSede
                    }
                    name="cittaSede"
                    onChange={handleChange}
                    className={classes.textfield}
                  />
                  <TextField
                    label="Provincia"
                    value={
                      record.esercizio.provinciaSede === null
                        ? ''
                        : record.esercizio.provinciaSede
                    }
                    name="provinciaSede"
                    onChange={handleChange}
                    className={classes.textfield}
                  />
                  <TextField
                    label="Codice SDI"
                    value={
                      record.esercizio.codiceSdi === null
                        ? ''
                        : record.esercizio.codiceSdi
                    }
                    name="codiceSdi"
                    onChange={handleChange}
                    className={classes.textfield}
                  />
                  <TextField
                    label="PEC"
                    value={
                      record.esercizio.pec === null ? '' : record.esercizio.pec
                    }
                    name="pec"
                    onChange={handleChange}
                    className={classes.textfield}
                  />
                  <TextField
                    label="termini d'uso e privacy policy accettate"
                    disabled
                    value={
                      record.esercizio.privacyPolicyAccettata &&
                      record.esercizio.terminiUsoAccettati
                        ? 'Si'
                        : 'No'
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                    className={classes.textfield}
                  />
                </Grid>
              </Grid>
            </Grid>
            {gestioneOperativaOpen && (
              <Grid container>
                <Grid item xs={12} className={classes.checkboxContainer}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="gestioneOperativaSeparata"
                        color="primary"
                        checked={record.esercizio.gestioneOperativaSeparata}
                        onChange={handleChange}
                      />
                    }
                    disabled={
                      record.aggiornamentoGestioneOperativaDTO &&
                      record.esercizio.gestioneOperativaSeparata
                    }
                    label="Selezionare la casella per gestione operativa separata dal manuale"
                  />
                </Grid>
              </Grid>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

FormDettagli.propTypes = {
  handleChange: PropTypes.func.isRequired,
  record: PropTypes.object.isRequired,
  validationErrors: PropTypes.object.isRequired,
  gestioneOperativaOpen: PropTypes.bool,
};

export default FormDettagli;
